import { createQueryKeys, type Query } from '@shared/api';

/**
 * Ключи запросов руководств.
 *
 * Семейства два, и делит их не удобство, а права: у администратора есть `manuals.manage`, поэтому
 * «список для окна» и «список для вкладки» — разные ответы одной ручки (план §3.3). Общий ключ
 * показал бы ему в окне снятые с публикации руководства — те самые, которые он только что оттуда
 * и убрал.
 *
 * После заведения, правки и удаления вкладка гасит `root`, а не свой `list(params)`: разделение
 * ключей спасает от смешения ответов, но само по себе оставило бы окно с устаревшим списком до
 * перезагрузки страницы.
 */
export const manualKeys = createQueryKeys('manuals', {
  /** Список вкладки ведения: фильтры, страница и сортировка входят в ключ. */
  list: (params: Query) => ['list', params],
  /** То, что показывает окно: только опубликованные, порядком справочника. */
  active: () => ['active'],
});
